import configData from "./config.json";

const { REACT_APP_API_URL,REACT_APP_API_URL_LOCAL } = configData;
const URL = window.location.hostname === 'localhost' ? REACT_APP_API_URL_LOCAL : REACT_APP_API_URL;
export const URL_LIST_ALL = URL ;